import { Option } from "@/@types/generics/Option";

export function filterOptions<T>(search: string, options: Option<T>[]) {
	return options.filter((option) => {
		const optionLabel = option.label.toLowerCase();

		return optionLabel.includes(search.toLowerCase());
	});
}